import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
const _hoisted_1 = { class: "text-body-2 text-medium-emphasis ml-3" };
import ChartPageThumbnail from "@/components/ChartPageThumbnail.vue";
/** One page of the picker's document at reading size, with the same include / exclude choice as its thumbnail. */
const PREVIEW_WIDTH = 760;
const PREVIEW_HEIGHT = 984;
const MB = 1024 * 1024;
export default /*@__PURE__*/ _defineComponent({
    __name: 'ChartPagePreviewDialog',
    props: {
        modelValue: { type: Boolean },
        pdf: {},
        page: {},
        pageCount: {},
        selected: { type: Boolean },
        sizeBytes: {}
    },
    emits: ["update:modelValue", "update:page", "toggle"],
    setup(__props, { emit: __emit }) {
        const emit = __emit;
        const formatMb = (bytes) => (bytes / MB).toFixed(bytes < MB ? 2 : 1);
        return (_ctx, _cache) => {
            const _component_v_spacer = _resolveComponent("v-spacer");
            const _component_v_btn = _resolveComponent("v-btn");
            const _component_v_card_title = _resolveComponent("v-card-title");
            const _component_v_card_text = _resolveComponent("v-card-text");
            const _component_v_card_actions = _resolveComponent("v-card-actions");
            const _component_v_card = _resolveComponent("v-card");
            const _component_v_dialog = _resolveComponent("v-dialog");
            return (_openBlock(), _createBlock(_component_v_dialog, {
                "model-value": __props.modelValue,
                "max-width": "860",
                scrollable: "",
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => (emit('update:modelValue', $event)))
            }, {
                default: _withCtx(() => [
                    _createVNode(_component_v_card, null, {
                        default: _withCtx(() => [
                            _createVNode(_component_v_card_title, { class: "d-flex align-center" }, {
                                default: _withCtx(() => [
                                    _createTextVNode(" Page " + _toDisplayString(__props.page) + " of " + _toDisplayString(__props.pageCount) + " ", 1),
                                    _createElementVNode("span", _hoisted_1, _toDisplayString(formatMb(__props.sizeBytes)) + " MB", 1),
                                    _createVNode(_component_v_spacer),
                                    _createVNode(_component_v_btn, {
                                        icon: "mdi-close",
                                        variant: "text",
                                        size: "small",
                                        onClick: _cache[0] || (_cache[0] = ($event) => (emit('update:modelValue', false)))
                                    })
                                ]),
                                _: 1
                            }),
                            _createVNode(_component_v_card_text, { class: "d-flex justify-center" }, {
                                default: _withCtx(() => [
                                    (_openBlock(), _createBlock(ChartPageThumbnail, {
                                        key: __props.page,
                                        pdf: __props.pdf,
                                        page: __props.page,
                                        width: PREVIEW_WIDTH,
                                        height: PREVIEW_HEIGHT,
                                        class: "chart-page-preview"
                                    }, null, 8, ["pdf", "page"]))
                                ]),
                                _: 1
                            }),
                            _createVNode(_component_v_card_actions, null, {
                                default: _withCtx(() => [
                                    _createVNode(_component_v_btn, {
                                        variant: "text",
                                        "prepend-icon": "mdi-chevron-left",
                                        disabled: __props.page <= 1,
                                        onClick: _cache[1] || (_cache[1] = ($event) => (emit('update:page', __props.page - 1)))
                                    }, {
                                        default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
                                                _createTextVNode(" Previous ", -1)
                                            ]))]),
                                        _: 1
                                    }, 8, ["disabled"]),
                                    _createVNode(_component_v_btn, {
                                        variant: "text",
                                        "append-icon": "mdi-chevron-right",
                                        disabled: __props.page >= __props.pageCount,
                                        onClick: _cache[2] || (_cache[2] = ($event) => (emit('update:page', __props.page + 1)))
                                    }, {
                                        default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
                                                _createTextVNode(" Next ", -1)
                                            ]))]),
                                        _: 1
                                    }, 8, ["disabled"]),
                                    _createVNode(_component_v_spacer),
                                    _createVNode(_component_v_btn, {
                                        color: __props.selected ? 'error' : 'primary',
                                        variant: "tonal",
                                        "prepend-icon": __props.selected ? 'mdi-close-circle-outline' : 'mdi-check-circle-outline',
                                        onClick: _cache[3] || (_cache[3] = ($event) => (emit('toggle', __props.page)))
                                    }, {
                                        default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(__props.selected ? "Exclude page" : "Include page"), 1)
                                        ]),
                                        _: 1
                                    }, 8, ["color", "prepend-icon"])
                                ]),
                                _: 1
                            })
                        ]),
                        _: 1
                    })
                ]),
                _: 1
            }, 8, ["model-value"]));
        };
    }
});
